export const table = {
	defaultCategoryName: "Productos",
	exportExcel: "Exportar Excel",
	productCount: {
		singular: "producto",
		plural: "productos",
	},
	loading: {
		categories: "Cargando categorías",
		products: "Cargando Productos",
	},
	dropdown: {
		editCategory: "Editar categoría",
		deleteCategory: "Eliminar categoría",
		categoryButton: "Categoría",
	},
	columns: {
		bars: "Barras",
		barsTooltip: "Haz clic para ver las barras",
		barsLabel: "Barras",
		mountableTooltip: "Haz clic para ver el producto montable",
		productionRuleTooltip: "Haz clic para ver la regla de producción",
		active: "Situación",
		mountableDescription: "Montable",
		fiscalCode: "SKU",
		name: "Producto",
		category: "Categoría",
		hasProductionRule: "Hoja de datos",
		fiscalData: "Datos fiscales",
		value: "Precio",
		actions: "Acciones",
	},
	fiscalStatus: {
		testedTooltip: "Datos fiscales registrados y validados",
		errorTooltip: "Encontramos errores en los datos fiscales presentados",
		notTestedTooltip: "Datos fiscales registrados. Esperando prueba.",
	},
	variablePrice: "Variable",
	validation: {
		pricePositive: "El precio debe ser un valor positivo",
		maxValue: "El precio no debe superar el valor máximo permitido (21,474,836.47)",
	},
	priceUpdateSuccess: "El precio de {{productName}} ha sido actualizado exitosamente.",
	priceChangeModal: {
		title: "Cambiar precio del producto",
		description:
			"Estás cambiando el precio del producto <strong>{{productName}}</strong> a <strong>{{price}}</strong>.",
		secondParagraph:
			"Antes de salir de la edición del precio, confirma si deseas continuar con el cambio o cancelar.",
		cancelButton: "Cancelar",
		confirmButton: "Cambiar precio",
	},
	priceChangeInvalidModal: {
		title: "Valor inválido",
		description:
			"El valor ingresado no es válido. Se mantendrá el precio anterior del producto.",
		cancelButton: "Cancelar",
	},
	priceUpdateCancelledNotification: {
		title: "No se pudo actualizar el precio",
		description: "Mantenemos el último precio en el producto",
	},
	priceUpdateSuccessNotification: {
		title: "¡Precio actualizado con éxito!",
		description: "{{productName}} ha sido actualizado a {{price}}",
	},
	notifications: {
		copyImageSuccess: {
			title: "¡Éxito!",
			description: "Hash de imagen copiado al portapapeles",
		},
	},
	emptyState: {
		categoryWithoutProducts: "Categoría sin productos",
		noProductsFound: "No se encontraron productos",
		noProductsCreated: "Ningún producto creado",
		noProductsCreatedMessage:
			"Crea tu primer producto y vincúlalo a una categoría para que aparezca aquí",
		addProducts: "Agrega productos y vincúlalos a esta categoría.",
		addProductButton: "Agregar producto",
		noSearchResults: "No encontramos productos que coincidan con tu búsqueda de",
		clearSearchButton: "Limpiar búsqueda",
		clearFiltersButton: "Limpiar filtros",
		andToAppliedFilters: "y a los filtros aplicados",
		noProductsMatchingFilters:
			"No encontramos productos que coincidan con los filtros aplicados",
	},
};
